export default {
  label: {
    statusHeader: 'Estado',
    transitionsHeader: 'Transiciones',
  },
};
